import { FC } from 'react'
import { motion } from 'framer-motion'

interface Treatment {
  image: string
  title: string
  description: string
}

const treatments: Treatment[] = [
  {
    image: '/assets/piec_krokow_kosmetyki.webp',
    title: 'Advanced Cosmetology',
    description: 'Cutting-edge skincare treatments and aesthetic procedures.',
  },
  {
    image: '/assets/piec_krokow_opieka.webp',
    title: 'Personalized Care',
    description: 'Individualized treatment plans tailored to your unique needs.',
  },
]

const Treatments: FC = () => {
  return (
    <section className="py-20 lg:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-100px' }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <span className="section-tag">Our Treatments</span>
          <h2 className="section-heading">Personalized Care</h2>
        </motion.div>

        {/* Treatments Grid */}
        <div className="grid md:grid-cols-2 gap-8 max-w-4xl mx-auto">
          {treatments.map((treatment, index) => (
            <motion.div
              key={treatment.title}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: '-50px' }}
              transition={{ duration: 0.5, delay: index * 0.15 }}
              whileHover={{ y: -8 }}
              className="bg-off-white rounded-2xl overflow-hidden shadow-sm hover:shadow-xl transition-all duration-300 group"
            >
              <div className="aspect-[4/3] overflow-hidden">
                <img
                  src={treatment.image}
                  alt={treatment.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                />
              </div>
              
              <div className="p-6 sm:p-8">
                <h3 className="text-xl font-bold text-text-dark mb-3">
                  {treatment.title}
                </h3>
                
                <p className="text-text-gray">
                  {treatment.description}
                </p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default Treatments
